export default __webpack_public_path__ + "static/media/fiutt-logo-icon.5548a0e5.png";